import React from 'react';
import PropTypes from 'prop-types';
import { compose, pure } from 'recompose';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import HeaderNews from '../Header';
import ParseHtml from '../../../../core/ParseHTML';
import { StyledArticleColumn1 } from '../../style';

const TemplateText = ({ title, subtitle, body }) => (
  <StyledArticleColumn1>
    <Helmet>
      <title>{title || 'A3Mil Intranet'}</title> {/* Cambia el título aquí */}
    </Helmet>
    <HeaderNews title={title} subtitle={subtitle} />
    <ParseHtml html={body} />
  </StyledArticleColumn1>
);
TemplateText.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  body: PropTypes.string
};

export default compose(pure)(TemplateText);
